module.exports = __webpack_public_path__ + "de2728dd49bce4aea40a58fda9756372.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-small-green-s.png
// module id = 2288
// module chunks = 0